import { IDateInfo, IKakaoPayBookInfo } from "@/domain/entities/book";
import { IResultData } from "@/domain/entities/shared/result";
import TYPES from "@/ioc/identifiers";
import { IBookRepository } from "@/repositories/book/bookRepository.types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { inject, injectable } from "inversify";

export interface RequestKakaoPayUseCase {
  execute(
    autoSeatAssgin: boolean,
    seatsSelectable: boolean,
    turnId: string,
    getOnStationId: string,
    getOffStationId: string,
    dateInfos: IDateInfo[],
    isMonthlyBook: boolean
  ): Promise<IResultData<IKakaoPayBookInfo>>;
}

@injectable()
export class RequestKakaoPay implements RequestKakaoPayUseCase {
  constructor(
    @inject(TYPES.IBookRepository) private bookRepository: IBookRepository
  ) {}

  async execute(
    autoSeatAssgin: boolean,
    seatsSelectable: boolean,
    turnId: string,
    getOnStationId: string,
    getOffStationId: string,
    dateInfos: IDateInfo[],
    isMonthlyBook: boolean
  ): Promise<IResultData<IKakaoPayBookInfo>> {
    const requestKakaoPayResult: IResultData<IKakaoPayBookInfo> = {
      isSuccess: false,
    };

    await this.bookRepository
      .requestKakaoPay(
        autoSeatAssgin,
        seatsSelectable,
        turnId,
        getOnStationId,
        getOffStationId,
        dateInfos,
        isMonthlyBook
      )
      .then((result) => {
        result
          .map((result) => {
            requestKakaoPayResult.isSuccess = true;
            requestKakaoPayResult.data = result;
          })
          .mapErr((error) => {
            useSetResultCodeIfNeeded(requestKakaoPayResult, error);
            requestKakaoPayResult.errorMessage = error.message;
          });
      })
      .catch((error) => {
        requestKakaoPayResult.isSuccess = false;
        requestKakaoPayResult.errorMessage = error.message;
      });

    return requestKakaoPayResult;
  }
}
